import { AnnouncementsTotalPerCustomerListModel } from '../models/announcements-total-per-customer-list-model';
import { AnnouncementsTotalsPerCustomerFilter } from '../models/announcements-totals-per-customer-filter';
import { AdminStatsAndReportsModel } from '../models/admin-stats-and-reports-model';
import { UrlConfigContainer } from '../../../core/url-config';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { EmptyData } from '../../../core/models/empty-data';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';
import { SalesReportFilterModel } from '../models/sales-report-filter-model';
import {
  SalesReportModel,
  ProductReportModel,
} from '../models/sales-report-model';
import { SuspendedEmailAddress } from '../models/suspended-email-address';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { CvDatabaseReportFilterModel } from '@admin/stats-and-reports/shared/models/cv-database-report-filter-model';
import { CvDatabaseReportModel } from '../models/cv-database-report-model';
import { UserType } from '../../../shared/models/user-type.enum';
import { CvDatabaseClicksReportModel } from '@admin/stats-and-reports/shared/models/cv-database-clicks-report-model';
import { CvDatabaseInvitesDetailModel } from '@admin/stats-and-reports/shared/models/cv-database-invites-detail-model';
import { ServerValidationResult } from '@admin/shared/validation/server-validation-result';
import { CustomerJobseekerViewEventSourceEnum } from '../models/customer-jobseeker-view-event-source-enum';
import { CvDatabaseProductService } from '@admin/product-purchases/shared/services/cv-database-product-service.service';
import { IndexationReport } from '../models/indexation-report.model';

@Injectable()
export class StatsAndReportsService {
  public getStats() {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.statsandreports.get, {});
    return this.ajax.getData(url, EmptyData, AdminStatsAndReportsModel);
  }

  public getIndexationReport() {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getIndexationReport,
      {}
    );
    return this.ajax.getData(url, EmptyData, IndexationReport);
  }
  public getAnnouncementsTotalsPerCustomer(
    filter: AnnouncementsTotalsPerCustomerFilter
  ) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getAnnouncementsTotalsPerCustomer,
      {}
    );
    return this.ajax.postData(
      url,
      filter.toObject(),
      AnnouncementsTotalPerCustomerListModel
    );
  }

  public getSalesReport(filter: SalesReportFilterModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getSalesReport,
      {}
    );
    return this.ajax.getData(url, filter.toObject(), SalesReportModel);
  }

  public getUpgradeSalesReport(filter: SalesReportFilterModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getUpgradesSalesReport,
      {}
    );
    return this.ajax.getDataPaging(url, filter.toObject(), ProductReportModel);
  }

  public getCvDatabaseReport(filter: CvDatabaseReportFilterModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getCvDatabaseReport,
      {}
    );
    return this.ajax.postData(url, filter.toObject(), CvDatabaseReportModel);
  }

  public getCvDatabaseClicksReport(
    filter: CvDatabaseReportFilterModel,
    source: CustomerJobseekerViewEventSourceEnum
  ) {
    let data = {
      parameters: filter.toObject(),
      source: source,
    };
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getCvDatabaseClicksReport,
      {}
    );
    return this.ajax.postData(url, data, CvDatabaseClicksReportModel);
  }

  public getCvDatabaseInvitesDetail(filter: CvDatabaseReportFilterModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.getCvDatabaseInvitesDetail,
      {}
    );
    return this.ajax.postData(url, filter.toObject(), CvDatabaseInvitesDetailModel);
  }

  public getSuspendedEmails(
    pagingInfo: { start: number; limit: number },
    sortParams: { column: string; order: string }[],
    email: string,
    userType: UserType
  ) {
    let data = {
      Start: pagingInfo.start,
      Limit: pagingInfo.limit,
      SortParameters:
        sortParams &&
        sortParams.map((p) => {
          return { Column: p.column, Order: p.order };
        }),
      Email: email,
      UserTypeId: userType,
    };
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.statsandreports.getSuspendedEmails,
      data,
      SuspendedEmailAddress
    );
  }

  public processSuspendedEmail(id: number) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.statsandreports.processSuspendedEmail,
      { suspendedEmailAddressId: id },
      EmptyData
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
